import BackBtn from './../UI/interface/icons/back-btn.svg'
import Close from './../UI/interface/icons/close.svg'
import BackGallery from './../UI/interface/icons/back-gallery.svg'
import Ficha from './../UI/interface/icons/ficha.svg'
import Ficha2 from './../UI/interface/icons/ficha2.svg'
import Ico360 from './../UI/interface/icons/360.svg'
import Ico3602 from './../UI/interface/icons/3602.svg'
import Ico180 from './../UI/interface/icons/vista180.svg'
import Ico1802 from './../UI/interface/icons/vista1802.svg'
import Galeria from './../UI/interface/icons/gallery.svg'
import Galeria2 from './../UI/interface/icons/gallery2.svg'
import Facebook from './../UI/interface/icons/facebook.svg'
import Insta from './../UI/interface/icons/insta.svg'
import YouTube from './../UI/interface/icons/youtube.svg'

import rotate from './../UI/interface/icons/rotate.svg'
import phone from './../UI/interface/icons/phone.svg'

import out from './../UI/interface/icons/CarOUT.png'

import E2 from './../UI/interface/icons-cars/e2.svg';
import YUAN300 from './../UI/interface/icons-cars/Yuan300.svg';
import YUAN400 from './../UI/interface/icons-cars/Yuan400.svg';
import T3 from './../UI/interface/icons-cars/t3.svg';
import M3 from './../UI/interface/icons-cars/m3.svg';
import SONGPRO from './../UI/interface/icons-cars/songpro.svg';

import E2BLACK from './../UI/interface/icons-cars/ev-black.svg';
import YUAN300BLACK from './../UI/interface/icons-cars/Yuan300-black.svg';
import YUAN400BLACK from './../UI/interface/icons-cars/Yuan400-black.svg';
import T3BLACK from './../UI/interface/icons-cars/t3-black.svg';
import M3BLACK from './../UI/interface/icons-cars/m3-black.svg';
import SONGPROBLACK from './../UI/interface/icons-cars/songpro-black.svg';

const Icons = {
    "back": BackBtn,
    "ficha": Ficha,
    "ficha2": Ficha2,
    "360": Ico360,
    "3602": Ico3602,
    "Galeria": Galeria,
    "Galeria2": Galeria2,
    "Facebook": Facebook,
    "Insta": Insta,
    "Youtube": YouTube,
    "180": Ico180,
    "1802": Ico1802,

    'rotate': rotate,
    'phone': phone,

    "Close": Close,
    "back-gallery": BackGallery,
    "out": out,

    "HATCHBACK EV": E2,
    "YUAN 300": YUAN300,
    "YUAN 400": YUAN400,
    "T3": T3,
    "M3": M3,
    "SONG PRO": SONGPRO,

    "HATCHBACK EV BLACK": E2BLACK,
    "YUAN 300 BLACK": YUAN300BLACK,
    "YUAN 400 BLACK": YUAN400BLACK,
    "T3 BLACK": T3BLACK,
    "M3 BLACK": M3BLACK,
    "SONG PRO BLACK": SONGPROBLACK,
}

export default Icons